import {
  generateClient,
  get,
  isCancelError,
  isCancelError as storageIsCancelError,
  post,
  put,
  del,
} from "aws-amplify/api";
import awsconfig from "../../aws-exports";
import { getUrl, uploadData } from "aws-amplify/storage";
import { resizeProfilePicture } from "../../Utils";

const client = generateClient();

export async function requestCreateBusiness(dispatch, payload) {
  try {
    dispatch({ type: "REQUEST_CREATE_BUSINESS" });
    const { input } = payload;
    const res = await client.graphql({
      query: createBusiness,
      variables: { input },
    });
    const business = res.data.createBusiness;
    dispatch({ type: "SUCCESS_CREATE_BUSINESS", payload: { business } });
    return business;
  } catch (error) {
    dispatch({ type: "ERROR_CREATE_BUSINESS", error });
    return null;
  }
}

export async function requestListBusiness(dispatch, payload) {
  try {
    dispatch({ type: "REQUEST_LIST_BUSINESS" });
    const { owner } = payload;
    let items = [];
    let nextToken = "start";
    while (nextToken) {
      const params = { limit: 20, owner };
      if (nextToken && nextToken !== "start") {
        params.nextToken = nextToken;
      }

      const res = await client.graphql({
        query: businessByOwnerCreatedAt,
        variables: params,
      });

      items = [...items, ...res.data.businessByOwnerCreatedAt.items];
      nextToken = res.data.businessByOwnerCreatedAt.nextToken;
    }
    items = items.map((item) => {
      item.label = item.name;
      item.value = item.id;
      return item;
    });
    dispatch({
      type: "SUCCESS_LIST_BUSINESS",
      payload: { items },
    });
  } catch (error) {
    dispatch({ type: "ERROR_LIST_BUSINESS", payload: { error } });
  }
}

export async function requestGetBusiness(dispatch, payload) {
  try {
    const { id } = payload;
    dispatch({ type: "REQUEST_GET_BUSINESS" });
    const params = {
      id,
    };
    const res = await client.graphql({
      query: getBusiness,
      variables: params,
    });
    const business = res.data.getBusiness;
    if (!business) throw new Error("Business not found.");

    business.imageUrl = null;

    if (business.image?.key) {
      const { key } = business.image;
      try {
        const urlResult = await getUrl({
          path: ({ identityId }) => `protected/${identityId}/${key}`,
          options: {
            useAccelerateEndpoint: true,
          },
        });
        const signedUrl = urlResult.url.href;
        business.imageUrl = signedUrl;
      } catch (error) {}
    }

    dispatch({
      type: "GET_BUSINESS_SUCCESS",
      payload: { business },
    });
  } catch (error) {
    dispatch({ type: "GET_BUSINESS_ERROR", payload: { error } });
  }
}

export async function requestUpdateBusiness(dispatch, payload) {
  try {
    dispatch({ type: "REQUEST_UPDATE_BUSINESS" });
    const { input, businessID } = payload;
    if (businessID) {
      const request = put({
        apiName: "user",
        path: "/mainBusiness",
        options: {
          body: {
            businessID,
          },
        },
      });
      await request.response;
    }
    if (input.image) {
      const file = await resizeProfilePicture(input.image);

      delete input.image;

      const key = `business/${input.id}/image/${file.name}`;

      const upload = uploadData({
        path: ({ identityId }) => `protected/${identityId}/${key}`,
        data: file,
      });

      const result = await upload.result;

      if (result.path) {
        input.image = {
          key,
          bucket: awsconfig.aws_user_files_s3_bucket,
          region: awsconfig.aws_user_files_s3_bucket_region,
        };
      }
    }

    const res = await client.graphql({
      query: updateBusiness,
      variables: { input },
    });
    const business = res.data.updateBusiness;
    dispatch({ type: "UPDATE_BUSINESS_SUCCESS", payload: { business } });
  } catch (error) {
    dispatch({ type: "ERROR_UPDATE_BUSINESS", error: error });
  }
}

export async function clearUpdateBusiness(dispatch) {
  dispatch({ type: "CLEAR_UPDATE_BUSINESS" });
}

export async function requestGetTaxDetail(dispatch, payload) {
  try {
    dispatch({ type: "REQUEST_GET_TAX_DETAIL" });
    const { businessID, startDate, endDate } = payload;
    const request = post({
      apiName: "cashbook",
      path: "/tax",
      options: {
        body: {
          businessID,
          startDate,
          endDate,
        },
      },
    });
    const { body } = await request.response;
    const res = await body.json();
    dispatch({
      type: "GET_TAX_DETAIL_SUCCESS",
      payload: { taxDetail: res.data },
    });
  } catch (error) {
    dispatch({ type: "GET_TAX_DETAIL_ERROR", error });
  }
}

export async function clearTaxDetail(dispatch) {
  dispatch({ type: "CLEAR_TAX_DETAIL" });
}

export async function resetNewBusiness(dispatch) {
  dispatch({ type: "RESET_NEW_BUSINESS" });
}

export async function requestCashbookBusiness(dispatch, payload) {
  try {
    const { businessID, startDate, endDate } = payload;
    dispatch({ type: "REQUEST_CASHBOOK_BUSINESS" });
    const request = post({
      apiName: "cashbook",
      path: "/tax",
      options: {
        body: {
          businessID,
          startDate,
          endDate,
        },
      },
    });
    const { body } = await request.response;
    const res = await body.json();
    const cashbook = res.data;
    dispatch({ type: "SUCCESS_CASHBOOK_BUSINESS", payload: { cashbook } });
  } catch (error) {
    dispatch({ type: "ERROR_CASHBOOK_BUSINESS", error: error });
  }
}
export async function clearCashbookBusiness(dispatch) {
  dispatch({ type: "CLEAR_CASHBOOK_BUSINESS" });
}

export async function requestCreateBusinessTransaction(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_CREATE_BUSINESS_TRANSACTION",
      payload: { request: null },
    });
    const { input } = payload;
    const request = client.graphql({
      query: createBusinessTransaction,
      variables: { input },
    });
    dispatch({
      type: "REQUEST_CREATE_BUSINESS_TRANSACTION",
      payload: { request },
    });
    const res = await request;
    const transaction = res.data.createBusinessTransaction;
    dispatch({
      type: "SUCCESS_CREATE_BUSINESS_TRANSACTION",
      payload: { transaction },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({ type: "CANCEL_CREATE_BUSINESS_TRANSACTION" });
    } else {
      dispatch({ type: "ERROR_CREATE_BUSINESS_TRANSACTION", error });
    }
  }
}

export async function requestGetBusinessTransaction(dispatch, payload) {
  try {
    const { id } = payload;
    dispatch({ type: "REQUEST_GET_BUSINESS_TRANSACTION" });
    const params = {
      id,
    };
    const res = await client.graphql({
      query: getBusinessTransaction,
      variables: params,
    });
    const transaction = res.data.getBusinessTransaction;
    if (!transaction) throw new Error("Business Transaction not found.");
    dispatch({
      type: "GET_BUSINESS_TRANSACTION_SUCCESS",
      payload: { transaction },
    });
  } catch (error) {
    dispatch({ type: "GET_BUSINESS_TRANSACTION_ERROR", payload: { error } });
  }
}

export async function requestUpdateBusinessTransaction(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_UPDATE_BUSINESS_TRANSACTION",
      payload: { request: null },
    });
    const { input } = payload;
    const request = client.graphql({
      query: updateBusinessTransaction,
      variables: { input },
    });
    dispatch({
      type: "REQUEST_UPDATE_BUSINESS_TRANSACTION",
      payload: { request },
    });
    const res = await request;
    const transaction = res.data.updateBusinessTransaction;
    dispatch({
      type: "UPDATE_BUSINESS_TRANSACTION_SUCCESS",
      payload: { transaction },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({ type: "CANCEL_UPDATE_BUSINESS_TRANSACTION" });
    } else {
      dispatch({ type: "ERROR_UPDATE_BUSINESS_TRANSACTION", error });
    }
  }
}

export async function requestListBusinessTransaction(dispatch, payload) {
  try {
    const {
      page,
      businessID,
      limit = 10,
      createdAt,
      sortDirection = "DESC",
      nextToken = null,
    } = payload;

    dispatch({
      type: "REQUEST_LIST_BUSINESS_TRANSACTION",
      payload: { request: null, page },
    });
    const params = {
      businessID,
      type: "SALE",
      limit,
      sortDirection,
      nextToken,
    };
    if (createdAt) {
      params.typeCreatedAt = createdAt;
    }

    const request = client.graphql({
      query: transactionsByBusinessTypeCreatedAt,
      variables: params,
    });

    dispatch({
      type: "REQUEST_LIST_BUSINESS_TRANSACTION",
      payload: { request, page },
    });

    const res = await request;
    const { items, nextToken: token } =
      res.data.transactionsByBusinessTypeCreatedAt;
    const nextPage = page + 1;
    dispatch({
      type: "SUCCESS_LIST_BUSINESS_TRANSACTION",
      payload: { items, nextToken: token, nextPage },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "GET_LIST_BUSINESS_TRANSACTION_CANCEL",
      });
    } else {
      dispatch({ type: "ERROR_LIST_BUSINESS_TRANSACTION", payload: { error } });
    }
  }
}

export async function requestDeleteCashTransaction(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_DELETE_CASH_TRANSACTION",
      payload: { request: null },
    });
    const { id } = payload;

    const request = client.graphql({
      query: deleteBusinessTransaction,
      variables: { input: { id } },
    });
    dispatch({ type: "REQUEST_DELETE_CASH_TRANSACTION", payload: { request } });

    const res = await request;

    dispatch({
      type: "DELETE_CASH_TRANSACTION_SUCCESS",
      payload: { id: res.data.deleteBusinessTransaction.id },
    });
  } catch (error) {
    dispatch({ type: "DELETE_CASH_TRANSACTION_ERROR", error });
  }
}

export async function resetNewBusinessTransaction(dispatch) {
  dispatch({ type: "RESET_NEW_BUSINESS_TRANSACTION" });
}

export async function resetUpdateBusinessTransaction(dispatch) {
  dispatch({ type: "RESET_UPDATE_BUSINESS_TRANSACTION" });
}

export async function clearGetBusiness(dispatch) {
  dispatch({ type: "CLEAR_GET_BUSINESS" });
}

export async function requestDocumentExcelUpload(dispatch, payload) {
  const { file, businessID } = payload;

  try {
    dispatch({ type: "REQUEST_UPLOAD_DOCUMENT_EXCEL" });

    const key = `cashbook/${file.name}`;

    const upload = uploadData({
      path: ({ identityId }) => `private/${identityId}/${key}`,
      data: file,
      options: {
        contentType: file.type,
        onProgress: (progress) => {
          dispatch({
            type: "UPLOAD_DOCUMENT_EXCEL_PENDING",
            payload: { progress, upload },
          });
        },
      },
    });

    const result = await upload.result;

    const input = {
      business_id: businessID,
    };

    if (result.path) {
      input.file = {
        key,
        bucket: awsconfig.aws_user_files_s3_bucket,
        region: awsconfig.aws_user_files_s3_bucket_region,
      };
    }

    const request = post({
      apiName: "cashbook",
      path: "/upload",
      options: {
        body: input,
      },
    });

    const { body } = await request.response;
    const res = await body.json();

    const { items } = res.data;

    dispatch({
      type: "UPLOAD_DOCUMENT_EXCEL_SUCCESS",
      payload: { excelTransactions: items },
    });
  } catch (error) {
    if (storageIsCancelError(error)) {
      dispatch({
        type: "UPLOAD_DOCUMENT_EXCEL_ERROR",
        error: null,
      });
    } else {
      dispatch({ type: "UPLOAD_DOCUMENT_EXCEL_ERROR", error });
    }
  }
}

export async function requestCreateExcelTransactions(dispatch, payload) {
  const { transactions, businessID } = payload;
  try {
    dispatch({ type: "REQUEST_CREATE_EXCEL_TRANSACTIONS" });

    const request = put({
      apiName: "cashbook",
      path: "/transaction",
      options: {
        body: {
          business_id: businessID,
          transactions,
        },
      },
    });
    const { body } = await request.response;
    const res = await body.json();
    const { items } = res.data;

    dispatch({
      type: "SUCCESS_CREATE_EXCEL_TRANSACTIONS",
      payload: { newExcelTransactions: items },
    });
  } catch (error) {
    dispatch({ type: "ERROR_CREATE_EXCEL_TRANSACTIONS", error });
  }
}

export async function clearCreateExcelTransactions(dispatch) {
  dispatch({ type: "CLEAR_CREATE_EXCEL_TRANSACTIONS" });
}

export async function clearDocumentExcelUpload(dispatch) {
  dispatch({ type: "CLEAR_UPLOAD_DOCUMENT_EXCEL" });
}

export async function requestListBusinessPartner(dispatch, payload) {
  try {
    const { page, businessID, limit, nextTokens } = payload;

    dispatch({
      type: "REQUEST_LIST_BUSINESS_PARTNER",
      payload: { request: null, page },
    });

    let items = [];
    let nextToken = nextTokens || "start";

    const params = {
      businessID,
      limit,
      sortDirection: "ASC",
    };

    while (nextToken && items.length === 0) {
      if (nextToken && nextToken !== "start") {
        params.nextToken = nextToken;
      }

      const request = client.graphql({
        query: partnersByBusinessCreatedAt,
        variables: params,
      });
      dispatch({
        type: "REQUEST_LIST_BUSINESS_PARTNER",
        payload: { request, page },
      });

      // eslint-disable-next-line no-await-in-loop
      const res = await request;
      items = [...items, ...res.data.partnersByBusinessCreatedAt.items];
      nextToken = res.data.partnersByBusinessCreatedAt.nextToken;
    }

    const nextPage = page + 1;

    dispatch({
      type: "LIST_BUSINESS_PARTNER_SUCCESS",
      payload: {
        items,
        nextToken,
        nextPage,
      },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "LIST_BUSINESS_PARTNER_CANCEL",
      });
    } else {
      dispatch({ type: "LIST_BUSINESS_PARTNER_ERROR", error });
    }
  }
}

export async function requestCreateBusinessPartner(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_CREATE_BUSINESS_PARTNER",
      payload: { request: null },
    });
    const { input } = payload;
    const request = client.graphql({
      query: createBusinessPartner,
      variables: { input },
    });

    dispatch({ type: "REQUEST_CREATE_BUSINESS_PARTNER", payload: { request } });

    const res = await request;
    const partner = res.data.createBusinessPartner;
    dispatch({
      type: "SUCCESS_CREATE_BUSINESS_PARTNER",
      payload: { partner },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "CANCEL_CREATE_BUSINESS_PARTNER",
      });
    } else {
      dispatch({ type: "ERROR_CREATE_BUSINESS_PARTNER", error });
    }
  }
}

export async function requestUpdateBusinessPartner(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_UPDATE_BUSINESS_PARTNER",
      payload: { request: null },
    });
    const { input } = payload;
    const request = client.graphql({
      query: updateBusinessPartner,
      variables: { input },
    });
    dispatch({ type: "REQUEST_UPDATE_BUSINESS_PARTNER", payload: { request } });

    const res = await request;
    const partner = res.data.updateBusinessPartner;
    dispatch({
      type: "UPDATE_BUSINESS_PARTNER_SUCCESS",
      payload: { partner },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "CANCEL_UPDATE_BUSINESS_PARTNER",
      });
    } else {
      dispatch({ type: "ERROR_UPDATE_BUSINESS_PARTNER", error });
    }
  }
}

export async function requestDeleteBusinessPartner(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_DELETE_BUSINESS_PARTNER",
      payload: { request: null },
    });
    const { id } = payload;

    const request = client.graphql({
      query: deleteBusinessPartner,
      variables: { input: { id } },
    });
    dispatch({ type: "REQUEST_DELETE_BUSINESS_PARTNER", payload: { request } });

    const res = await request;

    dispatch({
      type: "DELETE_BUSINESS_PARTNER_SUCCESS",
      payload: { id: res.data.deleteBusinessPartner.id },
    });
  } catch (error) {
    dispatch({ type: "DELETE_BUSINESS_PARTNER_ERROR", error });
  }
}

export async function requestGetCashbookStats(dispatch, payload) {
  try {
    const { businessID, startDate, endDate } = payload;

    dispatch({
      type: "REQUEST_GET_CASHBOOK_STATS",
      payload: { cashbookStatsRequest: null },
    });

    const request = get({
      apiName: "cashbook",
      path: `/stats/${businessID}/${startDate}/${endDate}`,
    });

    dispatch({
      type: "REQUEST_GET_CASHBOOK_STATS",
      payload: { cashbookStatsRequest: request },
    });

    const { body } = await request.response;
    const res = await body.json();

    dispatch({
      type: "GET_CASHBOOK_STATS_SUCCESS",
      payload: { stats: res.data },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({ type: "GET_CASHBOOK_STATS_CANCEL" });
    } else {
      dispatch({ type: "GET_CASHBOOK_STATS_ERROR", payload: { error } });
    }
  }
}

export async function requestListPartnerCashTransaction(dispatch, payload) {
  try {
    const {
      page,
      partnerID,
      limit = 10,
      createdAt,
      sortDirection = "DESC",
      nextToken = null,
    } = payload;

    dispatch({
      type: "REQUEST_LIST_PARTNER_CASH_TRANSACTION",
      payload: { page },
    });
    const params = {
      partnerID,
      limit,
      sortDirection,
      nextToken,
    };
    if (createdAt) {
      params.createdAt = createdAt;
    }
    const res = await client.graphql({
      query: businessTransactionsByPartnerCreatedAt,
      variables: params,
    });
    const { items, nextToken: token } =
      res.data.businessTransactionsByPartnerCreatedAt;
    const nextPage = page + 1;
    dispatch({
      type: "SUCCESS_LIST_PARTNER_CASH_TRANSACTION",
      payload: { items, nextToken: token, nextPage },
    });
  } catch (error) {
    dispatch({
      type: "ERROR_LIST_PARTNER_CASH_TRANSACTION",
      payload: { error },
    });
  }
}

export async function requestCreateBusinessEmployee(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_CREATE_BUSINESS_EMPLOYEE",
      payload: { request: null },
    });
    const { input } = payload;

    const request = client.graphql({
      query: createBusinessEmployee,
      variables: { input },
    });

    dispatch({
      type: "REQUEST_CREATE_BUSINESS_EMPLOYEE",
      payload: { request },
    });

    const res = await request;
    const employee = res.data.createBusinessEmployee;
    dispatch({
      type: "CREATE_BUSINESS_EMPLOYEE_SUCCESS",
      payload: { employee },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "CREATE_BUSINESS_EMPLOYEE_ERROR",
        error: null,
      });
    } else {
      dispatch({ type: "CREATE_BUSINESS_EMPLOYEE_ERROR", error });
    }
  }
}

export async function requestListBusinessEmployee(dispatch, payload) {
  try {
    const { page, businessID, createdAt, limit, nextToken = null } = payload;

    dispatch({
      type: "REQUEST_LIST_BUSINESS_EMPLOYEE",
      payload: { request: null, page },
    });

    const params = {
      businessID,
      limit,
      sortDirection: "ASC",
      nextToken,
    };

    if (createdAt) {
      params.createdAt = createdAt;
    }

    const request = client.graphql({
      query: employeesByBusinessCreatedAt,
      variables: params,
    });
    dispatch({
      type: "REQUEST_LIST_BUSINESS_EMPLOYEE",
      payload: { request, page },
    });

    let res;
    try {
      res = await request;
    } catch (error) {
      // Amplify v6 throws a partial response as { data, errors }: a record
      // missing a required field comes back as null, the rest still load.
      if (!error?.data?.employeesByBusinessCreatedAt) throw error;
      res = error;
    }
    const { items, nextToken: token } = res.data.employeesByBusinessCreatedAt;
    const nextPage = page + 1;

    dispatch({
      type: "LIST_BUSINESS_EMPLOYEE_SUCCESS",
      payload: {
        items: (items || []).filter((item) => item?.id),
        nextToken: token,
        nextPage,
      },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "LIST_BUSINESS_EMPLOYEE_ERROR",
        error: null,
      });
    } else {
      dispatch({ type: "LIST_BUSINESS_EMPLOYEE_ERROR", error });
    }
  }
}

export async function requestUpdateBusinessEmployee(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_UPDATE_BUSINESS_EMPLOYEE",
      payload: { request: null },
    });

    const { input } = payload;
    const request = client.graphql({
      query: updateBusinessEmployee,
      variables: { input },
    });

    dispatch({
      type: "REQUEST_UPDATE_BUSINESS_EMPLOYEE",
      payload: { request },
    });

    const res = await request;
    const employee = res.data.updateBusinessEmployee;

    dispatch({
      type: "UPDATE_BUSINESS_EMPLOYEE_SUCCESS",
      payload: { employee },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "UPDATE_BUSINESS_EMPLOYEE_ERROR",
        error: null,
      });
    } else {
      dispatch({
        type: "UPDATE_BUSINESS_EMPLOYEE_ERROR",
        error,
      });
    }
  }
}

export async function requestDeleteBusinessEmployee(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_DELETE_BUSINESS_EMPLOYEE",
      payload: { request: null },
    });

    const { id } = payload;
    const request = client.graphql({
      query: deleteBusinessEmployee,
      variables: { input: { id } },
    });

    dispatch({
      type: "REQUEST_DELETE_BUSINESS_EMPLOYEE",
      payload: { request },
    });

    const res = await request;

    dispatch({
      type: "DELETE_BUSINESS_EMPLOYEE_SUCCESS",
      payload: { id: res.data.deleteBusinessEmployee.id },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "DELETE_BUSINESS_EMPLOYEE_ERROR",
        error: null,
      });
    } else {
      dispatch({
        type: "DELETE_BUSINESS_EMPLOYEE_ERROR",
        error,
      });
    }
  }
}

export async function requestGetBusinessEmployee(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_GET_BUSINESS_EMPLOYEE",
      payload: { request: null },
    });

    const { id } = payload;
    const request = client.graphql({
      query: getBusinessEmployee,
      variables: { id },
    });

    dispatch({
      type: "REQUEST_GET_BUSINESS_EMPLOYEE",
      payload: { request },
    });

    const res = await request;
    const employee = res.data.getBusinessEmployee;
    if (!employee) throw new Error("businessEmployeeNotFound");

    dispatch({
      type: "GET_BUSINESS_EMPLOYEE_SUCCESS",
      payload: { employee },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "GET_BUSINESS_EMPLOYEE_ERROR",
        error: null,
      });
    } else {
      dispatch({
        type: "GET_BUSINESS_EMPLOYEE_ERROR",
        error,
      });
    }
  }
}

export async function requestCreateEmployeeAllowances(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_CREATE_EMPLOYEE_ALLOWANCES",
      payload: { request: null },
    });

    const { allowances, employeeID } = payload;
    const createdAllowances = [];

    for (const allowance of allowances) {
      const input = {
        name: allowance.name,
        description: allowance.description,
        type: allowance.type.value,
        amount: Number(allowance.amount),
        employeeID,
      };

      const request = client.graphql({
        query: createEmployeeAllowance,
        variables: { input },
      });

      // eslint-disable-next-line no-await-in-loop
      const res = await request;
      createdAllowances.push(res.data.createEmployeeAllowance);
    }

    dispatch({
      type: "CREATE_EMPLOYEE_ALLOWANCES_SUCCESS",
      payload: { allowances: createdAllowances, employeeID },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "ERROR_CREATE_EMPLOYEE_ALLOWANCES",
        error: null,
      });
    } else {
      dispatch({ type: "ERROR_CREATE_EMPLOYEE_ALLOWANCES", error });
    }
  }
}

export async function requestUpdateEmployeeAllowances(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_UPDATE_EMPLOYEE_ALLOWANCES",
      payload: { request: null },
    });

    const { employee_id, allowances } = payload;
    const request = put({
      apiName: "business",
      path: "/employee/allowances",
      options: {
        body: {
          employee_id,
          allowances,
        },
      },
    });

    dispatch({
      type: "REQUEST_UPDATE_EMPLOYEE_ALLOWANCES",
      payload: { request },
    });

    const { body } = await request.response;
    const res = await body.json();

    dispatch({
      type: "UPDATE_EMPLOYEE_ALLOWANCES_SUCCESS",
      payload: { allowances: res.data },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "UPDATE_EMPLOYEE_ALLOWANCES_ERROR",
        error: null,
      });
    } else {
      dispatch({ type: "UPDATE_EMPLOYEE_ALLOWANCES_ERROR", error });
    }
  }
}

export async function requestUpdateEmployeeDeductions(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_UPDATE_EMPLOYEE_DEDUCTIONS",
      payload: { request: null },
    });

    const { employee_id, deductions } = payload;
    const request = put({
      apiName: "business",
      path: "/employee/deductions",
      options: {
        body: {
          employee_id,
          deductions,
        },
      },
    });

    dispatch({
      type: "REQUEST_UPDATE_EMPLOYEE_DEDUCTIONS",
      payload: { request },
    });

    const { body } = await request.response;
    const res = await body.json();

    dispatch({
      type: "UPDATE_EMPLOYEE_DEDUCTIONS_SUCCESS",
      payload: { deductions: res.data },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "UPDATE_EMPLOYEE_DEDUCTIONS_ERROR",
        error: null,
      });
    } else {
      dispatch({
        type: "UPDATE_EMPLOYEE_DEDUCTIONS_ERROR",
        error,
      });
    }
  }
}

export async function requestListEmployeeAttendance(dispatch, payload) {
  try {
    const {
      employeeID,
      page = 1,
      limit = 10,
      nextToken = "start",
      attendanceDate,
    } = payload;

    dispatch({
      type: "REQUEST_LIST_EMPLOYEE_ATTENDANCE",
      payload: { request: null, page },
    });

    const params = {
      employeeID,
      limit,
      attendanceDate,
    };

    let items = [];
    let token = "start";
    if (nextToken) {
      token = nextToken;
    }

    while (token) {
      if (token && token !== "start") {
        params.nextToken = token;
      }

      const request = client.graphql({
        query: attendanceByEmployeeAttendanceDate,
        variables: params,
      });

      dispatch({
        type: "REQUEST_LIST_EMPLOYEE_ATTENDANCE",
        payload: { request, page },
      });

      // eslint-disable-next-line no-await-in-loop
      const res = await request;
      items = [...items, ...res.data.attendanceByEmployeeAttendanceDate.items];
      token = res.data.attendanceByEmployeeAttendanceDate.nextToken;
    }

    const nextPage = page + 1;

    dispatch({
      type: "LIST_EMPLOYEE_ATTENDANCE_SUCCESS",
      payload: {
        items,
        nextToken: token,
        nextPage,
      },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "LIST_EMPLOYEE_ATTENDANCE_ERROR",
        error: null,
      });
    } else {
      dispatch({
        type: "LIST_EMPLOYEE_ATTENDANCE_ERROR",
        error,
      });
    }
  }
}

export async function requestCreateEmployeeAttendance(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_CREATE_EMPLOYEE_ATTENDANCE",
      payload: { request: null },
    });

    const { input } = payload;

    const request = post({
      apiName: "business",
      path: "/employee/attendance",
      options: {
        body: input,
      },
    });

    dispatch({
      type: "REQUEST_CREATE_EMPLOYEE_ATTENDANCE",
      payload: { request },
    });

    const { body } = await request.response;
    const res = await body.json();

    dispatch({
      type: "CREATE_EMPLOYEE_ATTENDANCE_SUCCESS",
      payload: { attendance: res.data },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "CREATE_EMPLOYEE_ATTENDANCE_ERROR",
        error: null,
      });
    } else {
      dispatch({
        type: "CREATE_EMPLOYEE_ATTENDANCE_ERROR",
        error,
      });
    }
  }
}

export async function requestUpdateEmployeeAttendance(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_UPDATE_EMPLOYEE_ATTENDANCE",
      payload: { request: null },
    });

    const { input } = payload;

    const request = put({
      apiName: "business",
      path: `/employee/attendance/${input.id}`,
      options: {
        body: {
          status: input.status,
          clockInTime: input.clockInTime,
          clockOutTime: input.clockOutTime,
        },
      },
    });

    dispatch({
      type: "REQUEST_UPDATE_EMPLOYEE_ATTENDANCE",
      payload: { request },
    });

    const { body } = await request.response;
    const res = await body.json();

    dispatch({
      type: "UPDATE_EMPLOYEE_ATTENDANCE_SUCCESS",
      payload: { attendance: res.data },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "UPDATE_EMPLOYEE_ATTENDANCE_ERROR",
        error: null,
      });
    } else {
      dispatch({
        type: "UPDATE_EMPLOYEE_ATTENDANCE_ERROR",
        error,
      });
    }
  }
}

export async function requestDeleteEmployeeAttendance(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_DELETE_EMPLOYEE_ATTENDANCE",
      payload: { request: null },
    });

    const { id } = payload;

    const request = del({
      apiName: "business",
      path: `/employee/attendance/${id}`,
    });

    dispatch({
      type: "REQUEST_DELETE_EMPLOYEE_ATTENDANCE",
      payload: { request },
    });

    const { body } = await request.response;
    const res = await body.json();

    dispatch({
      type: "DELETE_EMPLOYEE_ATTENDANCE_SUCCESS",
      payload: { id: res.data.id },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "DELETE_EMPLOYEE_ATTENDANCE_ERROR",
        error: null,
      });
    } else {
      dispatch({
        type: "DELETE_EMPLOYEE_ATTENDANCE_ERROR",
        error,
      });
    }
  }
}

export async function requestListBusinessCalendar(dispatch, payload) {
  try {
    const {
      page = 1,
      businessID,
      limit = 10,
      nextToken = null,
      holidayDateFilter = null,
    } = payload;

    dispatch({
      type: "REQUEST_LIST_BUSINESS_CALENDAR",
      payload: { request: null, page },
    });

    const params = {
      businessID,
      limit,
      nextToken,
      holidayDateFilter,
    };

    const request = generateClient().graphql({
      query: calendarsByBusiness,
      variables: params,
    });

    dispatch({
      type: "REQUEST_LIST_BUSINESS_CALENDAR",
      payload: { request, page },
    });

    const res = await request;
    const { items, nextToken: token } = res.data.calendarsByBusiness;
    const nextPage = page + 1;

    dispatch({
      type: "LIST_BUSINESS_CALENDAR_SUCCESS",
      payload: {
        items,
        nextToken: token,
        nextPage,
      },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "LIST_BUSINESS_CALENDAR_ERROR",
        error: null,
      });
    } else {
      dispatch({
        type: "LIST_BUSINESS_CALENDAR_ERROR",
        error,
      });
    }
  }
}

export async function requestCreateBusinessCalendar(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_CREATE_BUSINESS_CALENDAR",
      payload: { request: null },
    });

    const { input } = payload;

    const request = generateClient().graphql({
      query: createBusinessCalendar,
      variables: { input },
    });

    dispatch({
      type: "REQUEST_CREATE_BUSINESS_CALENDAR",
      payload: { request },
    });

    const res = await request;
    const calendar = res.data.createBusinessCalendar;

    dispatch({
      type: "CREATE_BUSINESS_CALENDAR_SUCCESS",
      payload: { calendar },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "CREATE_BUSINESS_CALENDAR_ERROR",
        error: null,
      });
    } else {
      dispatch({
        type: "CREATE_BUSINESS_CALENDAR_ERROR",
        error,
      });
    }
  }
}

export async function requestUpdateBusinessCalendar(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_UPDATE_BUSINESS_CALENDAR",
      payload: { request: payload.request },
    });

    const result = await client.graphql({
      query: updateBusinessCalendar,
      variables: payload,
    });

    dispatch({
      type: "UPDATE_BUSINESS_CALENDAR_SUCCESS",
      payload: { calendar: result.data.updateBusinessCalendar },
    });
  } catch (error) {
    dispatch({
      type: "UPDATE_BUSINESS_CALENDAR_ERROR",
      error: error,
    });
  }
}

export async function requestCreateCalendarHoliday(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_CREATE_CALENDAR_HOLIDAY",
      payload: { request: null },
    });

    const { input } = payload;

    const request = generateClient().graphql({
      query: createCalendarHoliday,
      variables: { input },
    });

    dispatch({ type: "REQUEST_CREATE_CALENDAR_HOLIDAY", payload: { request } });

    const res = await request;

    dispatch({
      type: "CREATE_CALENDAR_HOLIDAY_SUCCESS",
      payload: res.data.createCalendarHoliday,
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "CREATE_CALENDAR_HOLIDAY_ERROR",
        error: null,
      });
    } else {
      dispatch({
        type: "CREATE_CALENDAR_HOLIDAY_ERROR",
        error,
      });
    }
  }
}

export async function requestDeleteCalendarHoliday(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_DELETE_CALENDAR_HOLIDAY",
      payload: { request: null },
    });

    const { id } = payload;

    const request = client.graphql({
      query: deleteCalendarHoliday,
      variables: { input: { id } },
    });

    dispatch({
      type: "REQUEST_DELETE_CALENDAR_HOLIDAY",
      payload: { request },
    });

    const res = await request;

    dispatch({
      type: "DELETE_CALENDAR_HOLIDAY_SUCCESS",
      payload: { id: res.data.deleteCalendarHoliday.id },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "DELETE_CALENDAR_HOLIDAY_ERROR",
        error: null,
      });
    } else {
      dispatch({
        type: "DELETE_CALENDAR_HOLIDAY_ERROR",
        error,
      });
    }
  }
}

export async function requestGetEmployeeAttendanceSummary(dispatch, payload) {
  try {
    dispatch({
      type: "REQUEST_GET_EMPLOYEE_ATTENDANCE_SUMMARY",
      payload: { request: null },
    });

    const { id, year } = payload;
    const request = get({
      apiName: "business",
      path: `/employee/${id}/attendance/summary?year=${year}`,
    });

    dispatch({
      type: "REQUEST_GET_EMPLOYEE_ATTENDANCE_SUMMARY",
      payload: { request },
    });

    const { body } = await request.response;
    const res = await body.json();

    dispatch({
      type: "GET_EMPLOYEE_ATTENDANCE_SUMMARY_SUCCESS",
      payload: { summary: res.data },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "GET_EMPLOYEE_ATTENDANCE_SUMMARY_ERROR",
        error: null,
      });
    } else {
      dispatch({
        type: "GET_EMPLOYEE_ATTENDANCE_SUMMARY_ERROR",
        error,
      });
    }
  }
}

export const clearCalendarHoliday = (dispatch) => {
  dispatch({ type: "CLEAR_CALENDAR_HOLIDAY" });
};

export async function clearBusinessCalendar(dispatch) {
  dispatch({
    type: "CLEAR_BUSINESS_CALENDAR",
  });
}

export function resetAttendanceViewData(dispatch) {
  dispatch({ type: "RESET_ATTENDANCE_VIEW_DATA" });
}

export async function clearEmployeeAttendance(dispatch) {
  dispatch({ type: "CLEAR_EMPLOYEE_ATTENDANCE" });
}

export async function clearBusinessEmployee(dispatch) {
  dispatch({ type: "CLEAR_BUSINESS_EMPLOYEE" });
}

export async function clearBusinessPartner(dispatch) {
  dispatch({ type: "CLEAR_BUSINESS_PARTNER" });
}

export async function clearBusinessPartnerError(dispatch) {
  dispatch({ type: "CLEAR_BUSINESS_PARTNER_ERROR" });
}

export async function clearBusinessTransaction(dispatch) {
  dispatch({ type: "CLEAR_BUSINESS_TRANSACTION" });
}

export async function clearBusinessTransactionError(dispatch) {
  dispatch({ type: "CLEAR_BUSINESS_TRANSACTION_ERROR" });
}

export async function clearUpdateBusinessError(dispatch) {
  dispatch({ type: "CLEAR_UPDATE_BUSINESS_ERROR" });
}

const businessByOwnerCreatedAt = /* GraphQL */ `
  query BusinessByOwnerCreatedAt(
    $owner: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBusinessFilterInput
    $limit: Int
    $nextToken: String
  ) {
    businessByOwnerCreatedAt(
      owner: $owner
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        type
        structure
        category
        taxCategory
        status
        lastActivityAt
        statusChangedAt
        inactivityWarnedAt
        restrictedAt
        graceEndsAt
        deletedAt
        taxNumber
        yearRegistered
        address
        phone
        image {
          key
          bucket
          region
        }
        alwaysSync
        cashIncomeDebitAccountID
        cashIncomeDebitAccount {
          id
          businessID
          code
          name
          category
          type
          createdAt
          editable
          updatedAt
        }
        cashIncomeCreditAccountID
        cashIncomeCreditAccount {
          id
          businessID
          code
          name
          category
          type
          createdAt
          editable
          updatedAt
        }
        cashExpenseDebitAccountID
        cashExpenseDebitAccount {
          id
          businessID
          code
          name
          category
          type
          createdAt
          editable
          updatedAt
        }
        cashExpenseCreditAccountID
        fiscalYearStartMonth
        cashExpenseCreditAccount {
          id
          businessID
          code
          name
          category
          type
          createdAt
          editable
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

const createBusiness = /* GraphQL */ `
  mutation CreateBusiness($input: CreateBusinessInput!) {
    createBusiness(input: $input) {
      id
      name
      email
      type
      structure
      category
      taxCategory
      status
      lastActivityAt
      statusChangedAt
      inactivityWarnedAt
      restrictedAt
      graceEndsAt
      deletedAt
      taxNumber
      yearRegistered
      address
      phone
      alwaysSync
      cashIncomeDebitAccountID
      cashIncomeDebitAccount {
        id
        businessID
        code
        name
        category
        type
        createdAt
        editable
        updatedAt
      }
      cashIncomeCreditAccountID
      cashIncomeCreditAccount {
        id
        businessID
        code
        name
        category
        type
        createdAt
        editable
        updatedAt
      }
      cashExpenseDebitAccountID
      cashExpenseDebitAccount {
        id
        businessID
        code
        name
        category
        type
        createdAt
        editable
        updatedAt
      }
      cashExpenseCreditAccountID
      fiscalYearStartMonth
      cashExpenseCreditAccount {
        id
        businessID
        code
        name
        category
        type
        createdAt
        editable
        updatedAt
      }
      salesDiscountAccountID
      salesDiscountAccount {
        id
        businessID
        code
        name
        category
        type
        createdAt
        editable
        updatedAt
      }
      purchaseDiscountAccountID
      purchaseDiscountAccount {
        id
        businessID
        code
        name
        category
        type
        createdAt
        editable
        updatedAt
      }
      createdAt
      updatedAt
      transactions {
        items {
          id
          businessID
          type
          income
          expense
          note
          productID
          partnerID
          createdAt
          updatedAt
        }
        nextToken
      }
      products {
        items {
          id
          businessID
          name
          type
          price
          cost
          reference
          sellable
          purchasable
          taxBaseType
          taxBaseRate
          taxBasePercentage
          taxBaseFractionNumerator
          taxBaseFractionDenumerator
          currentStock
          stockLastUpdatedAt
          createdAt
          updatedAt
        }
        nextToken
      }
      partners {
        items {
          id
          businessID
          name
          email
          phone
          type
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;

const updateBusiness = /* GraphQL */ `
  mutation UpdateBusiness($input: UpdateBusinessInput!) {
    updateBusiness(input: $input) {
      id
      name
      email
      type
      structure
      category
      taxCategory
      status
      lastActivityAt
      statusChangedAt
      inactivityWarnedAt
      restrictedAt
      graceEndsAt
      deletedAt
      taxNumber
      yearRegistered
      address
      phone
      image {
        bucket
        region
        key
      }
      alwaysSync
      cashIncomeDebitAccountID
      cashIncomeDebitAccount {
        id
        businessID
        code
        name
        category
        type
        createdAt
        editable
        updatedAt
      }
      cashIncomeCreditAccountID
      cashIncomeCreditAccount {
        id
        businessID
        code
        name
        category
        type
        createdAt
        editable
        updatedAt
      }
      cashExpenseDebitAccountID
      cashExpenseDebitAccount {
        id
        businessID
        code
        name
        category
        type
        createdAt
        editable
        updatedAt
      }
      cashExpenseCreditAccountID
      fiscalYearStartMonth
      cashExpenseCreditAccount {
        id
        businessID
        code
        name
        category
        type
        createdAt
        editable
        updatedAt
      }
      salesDiscountAccountID
      salesDiscountAccount {
        id
        businessID
        code
        name
        category
        type
        createdAt
        editable
        updatedAt
      }
      purchaseDiscountAccountID
      purchaseDiscountAccount {
        id
        businessID
        code
        name
        category
        type
        createdAt
        editable
        updatedAt
      }
      createdAt
      updatedAt
      transactions {
        items {
          id
          businessID
          type
          income
          expense
          note
          productID
          partnerID
          createdAt
          updatedAt
        }
        nextToken
      }
      products {
        items {
          id
          businessID
          name
          type
          price
          cost
          reference
          sellable
          purchasable
          taxBaseType
          taxBaseRate
          taxBasePercentage
          taxBaseFractionNumerator
          taxBaseFractionDenumerator
          currentStock
          stockLastUpdatedAt
          createdAt
          updatedAt
        }
        nextToken
      }
      partners {
        items {
          id
          businessID
          name
          email
          phone
          type
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;

const getBusiness = /* GraphQL */ `
  query GetBusiness($id: ID!) {
    getBusiness(id: $id) {
      id
      name
      email
      type
      structure
      category
      taxCategory
      status
      lastActivityAt
      statusChangedAt
      inactivityWarnedAt
      restrictedAt
      graceEndsAt
      deletedAt
      transactions {
        items {
          id
          businessID
          type
          income
          expense
          note
          productID
          partnerID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      image {
        bucket
        region
        key
      }
      products {
        items {
          id
          businessID
          name
          type
          price
          cost
          reference
          sellable
          purchasable
          taxBaseType
          taxBaseRate
          taxBasePercentage
          taxBaseFractionNumerator
          taxBaseFractionDenumerator
          currentStock
          stockLastUpdatedAt
          createdAt
          updatedAt
        }
        nextToken
      }
      partners {
        items {
          id
          businessID
          name
          email
          phone
          type
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      taxNumber
      yearRegistered
      address
      phone
      alwaysSync
      cashIncomeDebitAccountID
      cashIncomeDebitAccount {
        id
        businessID
        code
        name
        category
        type
        createdAt
        editable
        updatedAt
      }
      cashIncomeCreditAccountID
      cashIncomeCreditAccount {
        id
        businessID
        code
        name
        category
        type
        createdAt
        editable
        updatedAt
      }
      cashExpenseDebitAccountID
      cashExpenseDebitAccount {
        id
        businessID
        code
        name
        category
        type
        createdAt
        editable
        updatedAt
      }
      cashExpenseCreditAccountID
      fiscalYearStartMonth
      cashExpenseCreditAccount {
        id
        businessID
        code
        name
        category
        type
        createdAt
        editable
        updatedAt
      }
      salesDiscountAccountID
      salesDiscountAccount {
        id
        businessID
        code
        name
        category
        type
        createdAt
        editable
        updatedAt
      }
      purchaseDiscountAccountID
      purchaseDiscountAccount {
        id
        businessID
        code
        name
        category
        type
        createdAt
        editable
        updatedAt
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;

const createBusinessTransaction = /* GraphQL */ `
  mutation CreateBusinessTransaction($input: CreateBusinessTransactionInput!) {
    createBusinessTransaction(input: $input) {
      id
      businessID
      type
      income
      expense
      note
      productID
      partnerID
      createdAt
      updatedAt
    }
  }
`;

const getBusinessTransaction = /* GraphQL */ `
  query GetBusinessTransaction($id: ID!) {
    getBusinessTransaction(id: $id) {
      id
      businessID
      type
      income
      expense
      note
      productID
      partnerID
      createdAt
      updatedAt
    }
  }
`;

const updateBusinessTransaction = /* GraphQL */ `
  mutation UpdateBusinessTransaction($input: UpdateBusinessTransactionInput!) {
    updateBusinessTransaction(input: $input) {
      id
      businessID
      type
      income
      expense
      note
      productID
      partnerID
      createdAt
      updatedAt
    }
  }
`;

const deleteBusinessTransaction = /* GraphQL */ `
  mutation DeleteBusinessTransaction($input: DeleteBusinessTransactionInput!) {
    deleteBusinessTransaction(input: $input) {
      id
      businessID
      type
      income
      expense
      note
      productID
      partnerID
      createdAt
      updatedAt
      product {
        id
        businessID
        name
        type
        price
        cost
        reference
        sellable
        purchasable
        taxBaseType
        taxBaseRate
        taxBasePercentage
        taxBaseFractionNumerator
        taxBaseFractionDenumerator
        currentStock
        stockLastUpdatedAt
        createdAt
        updatedAt
      }
      partner {
        id
        businessID
        name
        email
        phone
        type
        createdAt
        updatedAt
      }
    }
  }
`;

const transactionsByBusinessTypeCreatedAt = /* GraphQL */ `
  query TransactionsByBusinessTypeCreatedAt(
    $businessID: ID
    $typeCreatedAt: ModelBusinessTransactionByBusinessTypeCreatedAtCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBusinessTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    transactionsByBusinessTypeCreatedAt(
      businessID: $businessID
      typeCreatedAt: $typeCreatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        businessID
        type
        income
        expense
        note
        productID
        partnerID
        createdAt
        updatedAt
        product {
          id
          businessID
          name
          type
          price
          cost
          reference
          sellable
          purchasable
          taxBaseType
          taxBaseRate
          taxBasePercentage
          taxBaseFractionNumerator
          taxBaseFractionDenumerator
          currentStock
          stockLastUpdatedAt
          createdAt
          updatedAt
        }
        partner {
          id
          businessID
          name
          email
          phone
          type
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;

const partnersByBusinessCreatedAt = /* GraphQL */ `
  query PartnersByBusinessCreatedAt(
    $businessID: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBusinessPartnerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    partnersByBusinessCreatedAt(
      businessID: $businessID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        businessID
        inUse
        name
        email
        phone
        type
        taxNumber
        address
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

const createBusinessPartner = /* GraphQL */ `
  mutation CreateBusinessPartner($input: CreateBusinessPartnerInput!) {
    createBusinessPartner(input: $input) {
      id
      businessID
      name
      email
      phone
      type
      taxNumber
      address
      createdAt
      updatedAt
    }
  }
`;

const updateBusinessPartner = /* GraphQL */ `
  mutation UpdateBusinessPartner($input: UpdateBusinessPartnerInput!) {
    updateBusinessPartner(input: $input) {
      id
      businessID
      name
      email
      phone
      type
      taxNumber
      address
      createdAt
      updatedAt
    }
  }
`;

const deleteBusinessPartner = /* GraphQL */ `
  mutation DeleteBusinessPartner($input: DeleteBusinessPartnerInput!) {
    deleteBusinessPartner(input: $input) {
      id
      businessID
      name
      email
      phone
      type
      taxNumber
      address
      createdAt
      updatedAt
    }
  }
`;

const businessTransactionsByPartnerCreatedAt = /* GraphQL */ `
  query BusinessTransactionsByPartnerCreatedAt(
    $partnerID: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBusinessTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    businessTransactionsByPartnerCreatedAt(
      partnerID: $partnerID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        businessID
        type
        income
        expense
        note
        productID
        product {
          id
          businessID
          name
          type
          price
          cost
          reference
          sellable
          purchasable
          taxBaseType
          taxBaseRate
          taxBasePercentage
          taxBaseFractionNumerator
          taxBaseFractionDenumerator
          currentStock
          stockLastUpdatedAt
          createdAt
          updatedAt
        }
        partnerID
        partner {
          id
          businessID
          name
          email
          phone
          type
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

const createBusinessEmployee = /* GraphQL */ `
  mutation CreateBusinessEmployee($input: CreateBusinessEmployeeInput!) {
    createBusinessEmployee(input: $input) {
      id
      businessID
      firstName
      lastName
      email
      phone
      address
      birthPlace
      birthDate
      gender
      marriageStatus
      dependent
      idType
      idNumber
      npwp
      employeeID
      startDate
      endDate
      taxSubjectStartDate
      taxSubjectEndDate
      employmentStatus
      employmentType
      department
      position
      minimumWorkHoursPerDay
      standardWorkStartTime
      standardWorkEndTime
      lateThresholdMinutes
      earlyLeaveThresholdMinutes
      lateDeductionEnabled
      lateDeductionType
      lateDeductionRate
      lateDeductionMultiplier
      lateDeductionBasedOnSalary
      lateDeductionTiers {
        id
        fromMinutes
        toMinutes
        deductionRate
      }
      maxLateDeductionPerDay
      salaryType
      baseSalary
      paymentPeriod
      paymentMethod
      bankAccount {
        bankName
        bankBranch
        accountNumber
        accountHolderName
        swiftCode
      }
      taxMethod
      riskLevel
      createdAt
      updatedAt
    }
  }
`;

const employeesByBusinessCreatedAt = /* GraphQL */ `
  query EmployeesByBusinessCreatedAt(
    $businessID: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBusinessEmployeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    employeesByBusinessCreatedAt(
      businessID: $businessID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        businessID
        inUse
        firstName
        lastName
        email
        phone
        address
        birthPlace
        birthDate
        gender
        marriageStatus
        dependent
        idType
        idNumber
        npwp
        employeeID
        startDate
        endDate
        taxSubjectStartDate
        taxSubjectEndDate
        employmentStatus
        employmentType
        department
        position
        minimumWorkHoursPerDay
        standardWorkStartTime
        standardWorkEndTime
        lateThresholdMinutes
        earlyLeaveThresholdMinutes
        lateDeductionEnabled
        lateDeductionType
        lateDeductionRate
        lateDeductionMultiplier
        lateDeductionBasedOnSalary
        lateDeductionTiers {
          id
          fromMinutes
          toMinutes
          deductionRate
        }
        maxLateDeductionPerDay
        salaryType
        baseSalary
        paymentPeriod
        paymentMethod
        bankAccount {
          bankName
          bankBranch
          accountNumber
          accountHolderName
          swiftCode
        }
        allowances {
          items {
            id
            name
            description
            type
            frequency
            isTaxable
            startDate
            endDate
            amount
            employeeID
            createdAt
            updatedAt
          }
          nextToken
        }
        deductions {
          items {
            id
            name
            description
            type
            frequency
            isTaxable
            reduceIncome
            startDate
            endDate
            amount
            employeeID
            createdAt
            updatedAt
          }
          nextToken
        }
        taxMethod
        riskLevel
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

const updateBusinessEmployee = /* GraphQL */ `
  mutation UpdateBusinessEmployee($input: UpdateBusinessEmployeeInput!) {
    updateBusinessEmployee(input: $input) {
      id
      businessID
      firstName
      lastName
      email
      phone
      address
      birthPlace
      birthDate
      gender
      marriageStatus
      dependent
      idType
      idNumber
      npwp
      employeeID
      startDate
      endDate
      taxSubjectStartDate
      taxSubjectEndDate
      employmentStatus
      employmentType
      department
      position
      minimumWorkHoursPerDay
      standardWorkStartTime
      standardWorkEndTime
      lateThresholdMinutes
      earlyLeaveThresholdMinutes
      lateDeductionEnabled
      lateDeductionType
      lateDeductionRate
      lateDeductionMultiplier
      lateDeductionBasedOnSalary
      lateDeductionTiers {
        id
        fromMinutes
        toMinutes
        deductionRate
      }
      maxLateDeductionPerDay
      salaryType
      baseSalary
      paymentPeriod
      paymentMethod
      bankAccount {
        bankName
        bankBranch
        accountNumber
        accountHolderName
        swiftCode
      }
      allowances {
        items {
          id
          name
          description
          type
          frequency
          isTaxable
          startDate
          endDate
          amount
          employeeID
          createdAt
          updatedAt
        }
        nextToken
      }
      deductions {
        items {
          id
          name
          description
          type
          frequency
          isTaxable
          reduceIncome
          startDate
          endDate
          amount
          employeeID
          createdAt
          updatedAt
        }
        nextToken
      }
      taxMethod
      riskLevel
      createdAt
      updatedAt
      __typename
    }
  }
`;

const deleteBusinessEmployee = /* GraphQL */ `
  mutation DeleteBusinessEmployee($input: DeleteBusinessEmployeeInput!) {
    deleteBusinessEmployee(input: $input) {
      id
      businessID
      firstName
      lastName
      email
      phone
      address
      birthPlace
      birthDate
      gender
      marriageStatus
      dependent
      idType
      idNumber
      npwp
      employeeID
      startDate
      endDate
      taxSubjectStartDate
      taxSubjectEndDate
      employmentStatus
      employmentType
      department
      position
      minimumWorkHoursPerDay
      standardWorkStartTime
      standardWorkEndTime
      lateThresholdMinutes
      earlyLeaveThresholdMinutes
      lateDeductionEnabled
      lateDeductionType
      lateDeductionRate
      lateDeductionMultiplier
      lateDeductionBasedOnSalary
      lateDeductionTiers {
        id
        fromMinutes
        toMinutes
        deductionRate
      }
      maxLateDeductionPerDay
      salaryType
      baseSalary
      paymentPeriod
      paymentMethod
      bankAccount {
        bankName
        bankBranch
        accountNumber
        accountHolderName
        swiftCode
      }
      taxMethod
      riskLevel
      createdAt
      updatedAt
    }
  }
`;

const getBusinessEmployee = /* GraphQL */ `
  query GetBusinessEmployee($id: ID!) {
    getBusinessEmployee(id: $id) {
      id
      businessID
      firstName
      lastName
      email
      phone
      address
      birthPlace
      birthDate
      gender
      marriageStatus
      dependent
      idType
      idNumber
      npwp
      employeeID
      startDate
      endDate
      taxSubjectStartDate
      taxSubjectEndDate
      employmentStatus
      employmentType
      department
      position
      minimumWorkHoursPerDay
      standardWorkStartTime
      standardWorkEndTime
      lateThresholdMinutes
      earlyLeaveThresholdMinutes
      lateDeductionEnabled
      lateDeductionType
      lateDeductionRate
      lateDeductionMultiplier
      lateDeductionBasedOnSalary
      lateDeductionTiers {
        id
        fromMinutes
        toMinutes
        deductionRate
      }
      maxLateDeductionPerDay
      salaryType
      baseSalary
      paymentPeriod
      paymentMethod
      bankAccount {
        bankName
        bankBranch
        accountNumber
        accountHolderName
        swiftCode
      }
      allowances {
        items {
          id
          name
          description
          type
          frequency
          isTaxable
          startDate
          endDate
          amount
          employeeID
          createdAt
          updatedAt
        }
        nextToken
      }
      deductions {
        items {
          id
          name
          description
          type
          frequency
          isTaxable
          reduceIncome
          startDate
          endDate
          amount
          employeeID
          createdAt
          updatedAt
        }
        nextToken
      }
      taxMethod
      riskLevel
      createdAt
      updatedAt
    }
  }
`;

const createEmployeeAllowance = /* GraphQL */ `
  mutation CreateEmployeeAllowance($input: CreateEmployeeAllowanceInput!) {
    createEmployeeAllowance(input: $input) {
      id
      name
      description
      type
      amount
      createdAt
      updatedAt
    }
  }
`;

const attendanceByEmployeeAttendanceDate = /* GraphQL */ `
  query AttendanceByEmployeeAttendanceDate(
    $employeeID: ID
    $attendanceDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelEmployeeAttendanceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    attendanceByEmployeeAttendanceDate(
      employeeID: $employeeID
      attendanceDate: $attendanceDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeID
        businessID
        attendanceDate
        status
        clockInTime
        clockOutTime
        notes
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

const calendarsByBusiness = /* GraphQL */ `
  query CalendarsByBusiness(
    $businessID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelBusinessCalendarFilterInput
    $limit: Int
    $nextToken: String
    $holidayDateFilter: ModelStringKeyConditionInput
  ) {
    calendarsByBusiness(
      businessID: $businessID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        businessID
        name
        workWeekPattern
        effectiveFrom
        effectiveTo
        holidays(date: $holidayDateFilter) {
          nextToken
          items {
            calendarID
            createdAt
            date
            id
            isPaid
            name
            type
            updatedAt
          }
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

const createBusinessCalendar = /* GraphQL */ `
  mutation CreateBusinessCalendar($input: CreateBusinessCalendarInput!) {
    createBusinessCalendar(input: $input) {
      id
      businessID
      name
      workWeekPattern
      effectiveFrom
      effectiveTo
      createdAt
      updatedAt
      owner
    }
  }
`;

const updateBusinessCalendar = /* GraphQL */ `
  mutation UpdateBusinessCalendar($input: UpdateBusinessCalendarInput!) {
    updateBusinessCalendar(input: $input) {
      id
      businessID
      name
      workWeekPattern
      effectiveFrom
      effectiveTo
      createdAt
      updatedAt
    }
  }
`;

const createCalendarHoliday = /* GraphQL */ `
  mutation CreateCalendarHoliday($input: CreateCalendarHolidayInput!) {
    createCalendarHoliday(input: $input) {
      id
      calendarID
      date
      name
      type
      isPaid
      createdAt
      updatedAt
    }
  }
`;

export const deleteCalendarHoliday = /* GraphQL */ `
  mutation DeleteCalendarHoliday($input: DeleteCalendarHolidayInput!) {
    deleteCalendarHoliday(input: $input) {
      id
      calendarID
      date
      name
      type
      isPaid
      createdAt
      updatedAt
    }
  }
`;
